import { React } from "react";
import { Route, Routes } from "react-router-dom";

import "./App.scss";
import { Header, Footer } from "./components/commonComponents";
import {
  ChallengesCategoriesList,
  ChallengesList,
  ChallengeVideo,
  ChallengePage,
  KidsChallenges,
  ChallengeUpload,
  MultipleVideoView,
  ChannelsList,
  KidChannel,
  ChannelManagement,
  ChildVideoView,
  ChildVideoUpload,
  RestrictKidChannel,
} from "./components/pages";

import usersService from "./services/userService";
import Interceptor from "./services/auth/Interceptor";

const ReactRedirect = () => {
  if (window.location.hostname === "localhost") {
    usersService.goToMonolith("");
  } else if (window.location.hostname !== "localhost") {
    usersService.goToMonolith("");
  }
};

function App() {
  Interceptor();

  return (
    <>
      <Header />
        <Routes>
          <Route path="*" element={<ReactRedirect />} />
          <Route path="/" element={<ReactRedirect />} />
          <Route
            path="/challenges-categories"
            element={<ChallengesCategoriesList />}
          />
          <Route
            path="/challenges-categories/challenges-list/:categoryId"
            element={<ChallengesList />}
          />
          <Route
            path="/challenge-upload/:uploadType/:categoryId/:challengeId"
            element={<ChallengeUpload />}
          />
          <Route path="/challenge/:categoryId" element={<ChallengePage />}>
            <Route path="video/:challengeId" element={<ChallengeVideo />} />
            <Route path="list/:challengeId" element={<KidsChallenges />} />
          </Route>
          <Route
            path="videView/:categoryId/:challengeId/:userId"
            element={<MultipleVideoView />}
          />

          <Route path="kids-teach-kids">
            <Route path="channels" element={<ChannelsList />} />
            <Route path="channel-management" element={<ChannelManagement />} />
            <Route path="channel/:channelId" element={<KidChannel />} />
            <Route
              path="channel/:channelId/video/:videoId"
              element={<ChildVideoView />}
            />
            <Route path="video-upload" element={<ChildVideoUpload />} />

              <Route path="channels">
                <Route path=":userId" element={<ChannelsList />} />
                <Route
                  path=":userId/channel/:channelId"
                  element={<RestrictKidChannel />}
                />
                <Route
                  path=":userId/channel/:channelId/video/:videoId"
                  element={<ChildVideoView />}
                />
              </Route>
          </Route>
        </Routes>
      <Footer />
    </>
  );
}

export default App;
